/**
 * VenueController
 * Manage Venues
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

angular.module('flsControllers').controller('VenueController', ['$scope','$window','Venue', function($scope, $window, Venue){
  /**
   * Initial State of Scope
   */
  $scope.venues = [];
  $scope.results  = false;

  // SearchForm
  $scope.formData = {
    content_disabled:false,
    scopes:{}
  };


  /**
   * Remote Search for Resource
   *
   */
  $scope.search = function(p){
    // Form data
    var form = $scope.formData || {};

    // Initial State of Venues
    $scope.venues = [];

    // Initial Page Number
    form.page = p || 1

    // Disable search form
    form.content_disabled = true;

    // Injuected resource Venue will handle the search
    Venue.get(form, function(response){
      if (response){
        $scope.results  = response;

        // Push the item ito the array of Venues
        $scope.venues = response.data || [];

        // Enable the form
        $scope.formData.content_disabled = false;
      }
    }, function($error){
        _.each($error.data, function(error){
            $.publish('resource.error', error);
        });
    });
  }


  /**
   * Return the Venue to the upper scope, whatever it may be
   *
   * @param  Venue venue
   * @param  string as
   * @return Void
   */
  $scope.pushToParent = function(resource, as){
    $scope.$parent[as] = resource;
  }

  // init the venues on first load
  // $scope.venues = $scope.search();

}]);
